import { useState, useEffect } from 'react';
import { supported as lsSupported } from 'bv-local-storage';
import { hasSportsbook } from 'global-config';
import withLazyLoad from 'bv-lazy-load';
import { useWindowSize } from 'bv-hooks';
import { useSelector } from 'react-redux';

import { CenterContent, LocalStorageWarning } from './components';

const RightSidebar = withLazyLoad()('rightSidebar');
const SmartAppBanner = withLazyLoad()('layoutApps.smartAppBanner');
const FloatingNavigation = withLazyLoad()('layoutApps.floatingNavigation');
const LeftComponents = withLazyLoad()('layoutApps.leftComponents');
const ModalHelper = withLazyLoad()('layoutApps.modalHelper');

const LayoutView = () => {
  const floatingNavigation = useSelector((state) => state.floatingNavigation);
  const { isLargeOrGreater } = useWindowSize();
  const leftVisible = isLargeOrGreater || floatingNavigation?.stateLeftPanel;
  const [renderLeft, setRenderLeft] = useState(leftVisible);

  useEffect(() => {
    if (leftVisible) setRenderLeft(true);
  }, [leftVisible]);

  return (
    lsSupported() ? (
      <>
        <SmartAppBanner />
        {renderLeft && <LeftComponents />}
        {hasSportsbook && <RightSidebar />}
        <CenterContent />
        <FloatingNavigation />
        <ModalHelper />
      </>
    ) : <LocalStorageWarning />
  );
};

export default LayoutView;
